// テーマのイベントシステムからイベント名の定数をインポート
import {
  ThemeEvents
} from '@theme/events';

/**
 * 追従カートのカスタム要素
 * メインの購入ボタンが画面外になったときに下部バーを表示し、
 * variant-picker の選択状態と同期する
 */
class StickyCart extends HTMLElement {
  /** @type {Element | null} */
  #section = null;

  connectedCallback() {
    // body へ移すと closest が取れなくなるので、移す前の section を保持する
    const section = this.closest('.shopify-section');
    if (section) {
      this.#section = section;
    }

    // product-details の sticky スタッキングコンテキストから外す
    if (this.parentElement !== document.body) {
      // 既に body 上にある追従カートがあれば、セクション再描画で増えた重複を除去
      document.querySelectorAll('body > sticky-cart').forEach((el) => {
        if (el !== this) el.remove();
      });
      document.body.appendChild(this);
      return; // append 後に再度 connectedCallback が走る
    }

    if (!this.#section) return;

    this.#section.addEventListener(ThemeEvents.variantUpdate, this.handleVariantUpdate);
    this.setupIntersectionObserver();
  }

  disconnectedCallback() {
    if (this.#section) {
      this.#section.removeEventListener(ThemeEvents.variantUpdate, this.handleVariantUpdate);
    }

    if (this.observer) {
      this.observer.disconnect();
      this.observer = undefined;
    }
  }

  /**
   * メインのカートボタンを監視して追従バーの表示/非表示を制御
   */
  setupIntersectionObserver() {
    this.mainAddToCartButton = document.querySelector(
      '.buy-buttons-block add-to-cart-component[ref="addToCartButtonContainer"]'
    );
    if (!this.mainAddToCartButton) return;

    this.observer = new IntersectionObserver((entries) => {
      const bar = this.querySelector('[ref="stickyCartBar"]');
      if (!bar) return;

      entries.forEach((entry) => {
        // 画面外 かつ 上方向にスクロールした場合のみ表示
        if (!entry.isIntersecting && entry.boundingClientRect.bottom < 0) {
          bar.classList.add('is-visible');
        } else {
          bar.classList.remove('is-visible');
        }
      });
    });

    this.observer.observe(this.mainAddToCartButton);
  }

  /**
   * 既存のvariant-pickerからのVariantUpdateEventを受け取って追従カートを更新
   * @param {Event} event - バリエーション更新イベント
   */
  handleVariantUpdate = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newStickyCart = event.detail.data.html.querySelector('sticky-cart [ref="stickyCartContainer"]');
    const currentStickyCart = this.querySelector('[ref="stickyCartContainer"]');

    if (!newStickyCart || !currentStickyCart) return;

    currentStickyCart.replaceWith(newStickyCart);
  };
}

if (!customElements.get('sticky-cart')) {
  customElements.define('sticky-cart', StickyCart);
}
